
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPanelIlluminationIec as ObiPanelIlluminationIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-panel-illumination-iec.js';
 
 
 

 
 export const ObiPanelIlluminationIec = createComponent({
   react: React,
   tagName: 'obi-panel-illumination-iec',
   elementClass: ObiPanelIlluminationIecElement,
   events: {
     
   }
  });
 
 